const messages:Record<string,string>={
 nizan_only:'רק ניצן המחובר רשאי לאשר שינוי SQL. יש להתחבר מחדש לחשבון המתאים.',
 admin_queue_reason_required:'חסרה סיבה לאישור. לא נרשם אישור.',
 admin_queue_item_not_actionable:'מצב המיגרציה השתנה והיא אינה ממתינה לאישור. יש לרענן את הכרטיס.',
 admin_queue_emergency_required:'אישור מיידי זמין רק למיגרציה שמסומנת כחירום ועדיין ממתינה לאישור.',
 admin_queue_timeout:'השרת הפסיק את הבקשה בגלל חריגה מזמן ההמתנה. יש לרענן ולבדוק אם האישור נשמר לפני ניסיון נוסף.',
 admin_queue_lock_busy:'המיגרציה ננעלה זמנית בידי פעולה אחרת. לא נרשם אישור חדש; יש לרענן ולנסות שוב.',
 admin_queue_manual_source_changed:'מקור ה־SQL או האישור הידני השתנה. נדרשת בדיקת הגרסה העדכנית לפני אישור.',
 admin_queue_transport:'לא התקבלה תשובה מאומתת מהשרת. יש לבדוק את מצב המיגרציה לפני ניסיון נוסף.',
 admin_queue_protocol:'השרת לא החזיר קבלה תקינה לאישור. יש לבדוק את מצב המיגרציה לפני ניסיון נוסף.',
 admin_queue_refused:'השרת סירב לאישור המיגרציה. יש לרענן ולבדוק את המצב וההרשאה.',
}
export class AdminQueueFailure extends Error{
 constructor(readonly code:string,readonly phase:string,readonly db_code?:string,readonly uncertain=false){super(messages[code]??messages.admin_queue_refused)}
}
export function queueFailure(error:unknown,phase='approval'){
 if(error instanceof AdminQueueFailure)return error
 const e=error as any,raw=String(e?.message??e?.error??''),dbCode=String(e?.db_code??e?.code??'')
 const code=messages[e?.error]?e.error:messages[e?.code]?e.code:
  /nizan_only|verified owner required|42501/.test(raw+' '+dbCode)?'nizan_only':
  /reason required/.test(raw)?'admin_queue_reason_required':
  /item not actionable/.test(raw)?'admin_queue_item_not_actionable':
  /emergency pending item required/.test(raw)?'admin_queue_emergency_required':
  /57014|PGRST003|Thread killed by timeout manager|timed? out|timeout/i.test(raw+' '+dbCode)?'admin_queue_timeout':
  /55P03|lock not available/i.test(raw+' '+dbCode)?'admin_queue_lock_busy':
  /manual_sql_(?:item_missing|item_mismatch|source|review|approval_changed|hash)/.test(raw)?'admin_queue_manual_source_changed':'admin_queue_transport'
 return new AdminQueueFailure(code,phase,/^(?:[A-Z0-9]{5}|PGRST\d{3})$/.test(dbCode)?dbCode:undefined,['admin_queue_transport','admin_queue_protocol','admin_queue_timeout'].includes(code))
}
export function queueNightOpen(now=new Date()){
 const hour=Number(new Intl.DateTimeFormat('en-US',{timeZone:'Asia/Jerusalem',hour:'numeric',hourCycle:'h23'}).format(now))
 return hour>=23||hour<6
}
